/**
 * Fail-loud environment access.
 *
 * Pass the variable's value via a LITERAL process.env.NEXT_PUBLIC_* access at
 * the call site - Next.js only inlines env vars into the client bundle when
 * the full name appears literally in code. Never do process.env[name].
 *
 * A missing variable crashes the build/boot with a clear message instead of
 * silently falling back to a wrong environment.
 */
export function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${name}. ` +
        `Set it in the environment (Amplify app env vars / .env) before building.`,
    );
  }
  return value;
}
